<div class="MobileDayCell">
  <span class="MobileDayCell__DayNumber">
    {{ singleDay?.dayOfTheMonth }}
  </span>

  <span class="MobileDayCell__StatusPillContainer">
    @for (data of singleDay.data; track data) {
      <status
        class="MobileDayCell__StatusPill"
        [config]="{
          label: data.claim_type,
          matchColor: data.claim_status,
          capitalized: true,
          statuses: statusses,
        }"
        [isMobileView]="true"
      >
      </status>
    }
  </span>
</div>
